export const handleProtectedNavigation = ({
  user,
  intakeComplete,
  navigate,
  target,
}) => {
  const nextTarget = target || '/dashboard';

  if (!user) {
    const params = new URLSearchParams({
      guest: 'true',
      target: nextTarget,
    });
    navigate(`/intake?${params.toString()}`);
    return;
  }

  if (!intakeComplete) {
    const params = new URLSearchParams({
      target: nextTarget,
    });
    navigate(`/intake?${params.toString()}`);
    return;
  }

  navigate(nextTarget);
};
